import { Button } from "antd";
import React, { useEffect, useState } from "react";
import ProductFilterPanel from "./ProductFilterPanel";
import "./index.less";
import { useLocalStorageState } from "ahooks";
import { useLocation } from "react-router";
import { observer } from "mobx-react-lite";
import ProductFilterStore, { ProductFilterStoreContext } from "./store/ProductFilterStore";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";

interface ProductFilterProps {
    className?: string;
    showShopName?: boolean;
    tab: OrderTab;
}

const CACHE_PRODUCT_FILTER_VISIBLE_KEY = "__CACHE_PRODUCT_FILTER_VISIBLE_KEY__";

const ProductFilter: React.FC<ProductFilterProps> = function (props) {
    const { className, showShopName, tab } = props;
    const [visible, setVisible] = useLocalStorageState(CACHE_PRODUCT_FILTER_VISIBLE_KEY, { defaultValue: true });
    const location = useLocation();
    const orderManagementStore = useOrderManagementStore();
    const [store] = useState(() => new ProductFilterStore());

    useEffect(() => {
        const showProductFilter = new URLSearchParams(location.search).get("showProductFilter");

        if (showProductFilter) {
            setVisible(true);
        }
    }, []);

    return (
        <ProductFilterStoreContext.Provider value={store}>
            <span className="pr">
                <Button
                    size="small"
                    className={className}
                    id="product-filter-btn"
                    onClick={() => {
                        setVisible(!visible);
                    }}
                >
                    商品筛选
                </Button>

                {visible ? (
                    <ProductFilterPanel tab={tab} onOpenChange={setVisible} showShopName={showShopName} />
                ) : null}
            </span>
        </ProductFilterStoreContext.Provider>
    );
};

export default observer(ProductFilter);
